<template>
  <v-app>

    <!-- ══ FIXED HEADER ══ -->
    <div class="site-header">

      <!-- Top Bar -->
      <div class="top-bar">
        <span class="top-bar-address">Jinpara, Near Andh Apang Gaushala, Wankaner — Gujarat &nbsp;|&nbsp; તમારી કાર, અમારી જવાબદારી</span>
        <span class="top-bar-hours">Mon–Sat, 9 AM – 8 PM &nbsp;|&nbsp; 9723638209, 9228238209</span>
      </div>

      <!-- Navbar -->
      <div class="navbar">
        <div class="navbar-left">
          <img src="@/assets/SKM.png" alt="SKM" class="nav-logo" />
          <div class="navbar-brand">
            <span class="brand-white">SHREE KHODIYAR&nbsp;</span><span class="brand-red">MOTORS</span>
          </div>
        </div>

        <!-- Desktop nav links -->
        <div class="navbar-right">
          <router-link
            v-for="link in navLinks"
            :key="link.to"
            :to="link.to"
            class="nav-link"
            active-class="nav-link--active"
          >{{ link.label }}</router-link>
        </div>

        <!-- Mobile hamburger -->
        <button class="hamburger" @click="mobileMenuOpen = !mobileMenuOpen" :aria-expanded="mobileMenuOpen" aria-label="Toggle navigation">
          <span class="hamburger-line" :class="{ open: mobileMenuOpen }"></span>
          <span class="hamburger-line" :class="{ open: mobileMenuOpen }"></span>
          <span class="hamburger-line" :class="{ open: mobileMenuOpen }"></span>
        </button>
      </div>

      <!-- Mobile Menu Drawer -->
      <div class="mobile-menu" :class="{ 'mobile-menu--open': mobileMenuOpen }">
        <router-link
          v-for="link in navLinks"
          :key="link.to"
          :to="link.to"
          class="mobile-nav-link"
          active-class="mobile-nav-link--active"
          @click.native="mobileMenuOpen = false"
        >{{ link.label }}</router-link>
        <div class="mobile-menu-contact">
          <a href="tel:+919723638209" class="mobile-contact-btn">CALL NOW</a>
          <a href="https://wa.me/919723638209" target="_blank" rel="noopener noreferrer" class="mobile-whatsapp-btn">WHATSAPP</a>
        </div>
      </div>

    </div>

    <!-- Mobile menu overlay -->
    <div class="mobile-overlay" :class="{ 'mobile-overlay--open': mobileMenuOpen }" @click="mobileMenuOpen = false"></div>

    <!-- ══ CONTENT ══ -->
    <div class="site-content">
      <router-view />
    </div>

    <!-- ══ FOOTER ══ -->
    <div class="site-footer">
      <div class="footer-top">

        <!-- Col 1: Brand -->
        <div class="footer-brand">
          <img src="@/assets/SKM.png" alt="SKM" class="footer-logo" />
          <p class="footer-brand-desc">Car body work, painting &amp; detailing in Wankaner, Gujarat. Quality you can see, service you can trust.</p>
          <span class="footer-gujarati">તમારી કાર, અમારી જવાબદારી</span>
        </div>

        <!-- Col 2: Explore -->
        <div class="footer-col">
          <div class="footer-col-title">EXPLORE</div>
          <router-link to="/home" class="footer-link">Home</router-link>
          <router-link to="/services" class="footer-link">Services</router-link>
          <router-link to="/gallery" class="footer-link">Gallery</router-link>
          <router-link to="/contact" class="footer-link">Contact</router-link>
        </div>

        <!-- Col 3: Services -->
        <div class="footer-col">
          <div class="footer-col-title">SERVICES</div>
          <router-link to="/services" class="footer-link">Car Body Work</router-link>
          <router-link to="/services" class="footer-link">Car Painting</router-link>
          <router-link to="/services" class="footer-link">Detailing &amp; Coating</router-link>
          <router-link to="/services" class="footer-link">Insurance Claim Help</router-link>
        </div>

        <!-- Col 4: Contact -->
        <div class="footer-col">
          <div class="footer-col-title">GET IN TOUCH</div>
          <a href="tel:+919723638209" class="footer-link">97236 38209</a>
          <a href="tel:+919228238209" class="footer-link">92282 38209</a>
          <span class="footer-address">Jinpara, Near Andh Apang Gaushala,<br>Wankaner — Gujarat 363621</span>
          <span class="footer-hours">Mon–Sat · 9 AM – 8 PM</span>
        </div>

      </div>

      <div class="footer-bottom">
        <span class="footer-copy">&copy; 2026 Shree Khodiyar Motors. All rights reserved.</span>
        <span class="footer-tagline">BODY &nbsp;·&nbsp; PAINT &nbsp;·&nbsp; DETAILING</span>
      </div>
    </div>

  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      mobileMenuOpen: false,
      navLinks: [
        { to: '/home',     label: 'Home' },
        { to: '/services', label: 'Services' },
        { to: '/gallery',  label: 'Gallery' },
        { to: '/contact',  label: 'Contact' },
      ]
    }
  },
  watch: {
    $route() {
      this.mobileMenuOpen = false
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@700;800;900&display=swap');

*, *::before, *::after { box-sizing: border-box; }

body, html {
  font-family: 'Inter', sans-serif !important;
  background: #0d0d0d !important;
  margin: 0;
  padding: 0;
}

.v-application { background: #0d0d0d !important; }
.v-application--wrap {
  min-height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
}

/* ── FIXED HEADER ── */
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  display: flex;
  flex-direction: column;
}

/* Top Bar */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #161616;
  border-bottom: 1px solid rgba(204,0,0,0.2);
  padding: 0 40px;
  height: 36px;
  font-size: 12px;
  color: #777;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

/* Navbar */
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #111111;
  border-bottom: 2px solid #cc0000;
  padding: 0 40px;
  height: 90px;
  flex-shrink: 0;
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Logo */
.nav-logo {
  height: 74px;
  width: 74px;
  object-fit: contain;
  border-radius: 12px;
  background: #ffffff;
  padding: 5px;
  display: block;
  flex-shrink: 0;
}

/* Brand */
.brand-white {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 21px;
  color: #ffffff;
  letter-spacing: 2px;
}

.brand-red {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 21px;
  color: #cc0000;
  letter-spacing: 2px;
}

/* Nav links */
.v-application a.nav-link,
.v-application a.nav-link:visited {
  color: #ffffff !important;
}

.nav-link {
  color: #ffffff !important;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 8px 16px;
  position: relative;
  white-space: nowrap;
  transition: color 0.2s;
}

.nav-link:hover { color: #cc0000 !important; }

.nav-link--active,
.router-link-active.nav-link,
.router-link-exact-active.nav-link {
  color: #ffffff !important;
}

.nav-link--active::after,
.router-link-exact-active.nav-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 16px;
  right: 16px;
  height: 3px;
  background: #cc0000;
  border-radius: 2px;
}

/* ── CONTENT ── */
.site-content {
  margin-top: 126px; /* 36px topbar + 90px navbar */
  background: #0d0d0d;
  flex: 1;
}

/* ── HAMBURGER ── */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  flex-shrink: 0;
}
.hamburger:hover { background: rgba(255,255,255,0.05); }

.hamburger-line {
  display: block;
  width: 22px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform-origin: center;
}
.hamburger-line:nth-child(1).open { transform: translateY(7px) rotate(45deg); }
.hamburger-line:nth-child(2).open { opacity: 0; transform: scaleX(0); }
.hamburger-line:nth-child(3).open { transform: translateY(-7px) rotate(-45deg); }

/* ── MOBILE MENU ── */
.mobile-menu {
  display: none;
  flex-direction: column;
  background: #111;
  border-top: 1px solid rgba(204,0,0,0.3);
  padding: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease, padding 0.35s ease;
}
.mobile-menu--open {
  max-height: 400px;
  padding: 12px 0 20px;
}

.v-application a.mobile-nav-link,
.v-application a.mobile-nav-link:visited { color: #ccc !important; }
.v-application a.mobile-nav-link:hover,
.v-application a.mobile-nav-link--active { color: #fff !important; }

.mobile-nav-link {
  display: block;
  padding: 14px 24px;
  color: #ccc !important;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  transition: color 0.2s, background 0.2s;
}
.mobile-nav-link:hover,
.mobile-nav-link--active { color: #fff !important; background: rgba(204,0,0,0.08); }

.mobile-menu-contact {
  display: flex;
  gap: 10px;
  padding: 16px 24px 0;
  flex-wrap: wrap;
}

.v-application a.mobile-contact-btn,
.v-application a.mobile-contact-btn:visited {
  color: #fff !important;
}

.mobile-contact-btn {
  display: inline-flex;
  align-items: center;
  background: #cc0000;
  color: #fff !important;
  text-decoration: none;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 12px 20px;
  border-radius: 8px;
  flex: 1;
  justify-content: center;
  min-height: 44px;
}
.mobile-contact-btn:hover { background: #aa0000; }

.v-application a.mobile-whatsapp-btn,
.v-application a.mobile-whatsapp-btn:visited {
  color: #25d366 !important;
}

.mobile-whatsapp-btn {
  display: inline-flex;
  align-items: center;
  background: transparent;
  color: #25d366 !important;
  text-decoration: none;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 12px 20px;
  border-radius: 8px;
  border: 2px solid #25d366;
  flex: 1;
  justify-content: center;
  min-height: 44px;
}
.mobile-whatsapp-btn:hover { background: #25d366; color: #000 !important; }

/* ── MOBILE OVERLAY ── */
.mobile-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 199;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}
.mobile-overlay--open {
  opacity: 1;
  pointer-events: all;
}

/* ── FOOTER ── */
.site-footer {
  background: #0a0a0a;
  border-top: 1px solid rgba(204,0,0,0.25);
}

.footer-top {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 48px;
  padding: 56px 40px 48px;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-logo {
  height: 90px;
  width: 90px;
  object-fit: contain;
  border-radius: 12px;
  background: #fff;
  padding: 5px;
}

.footer-brand-desc {
  font-size: 13.5px;
  color: #666;
  line-height: 1.75;
  margin: 0;
  max-width: 280px;
}

.footer-gujarati {
  font-size: 13px;
  font-weight: 600;
  color: #cc0000;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-col-title {
  font-size: 11.5px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.v-application a.footer-link,
.v-application a.footer-link:visited {
  color: #666 !important;
}

.footer-link {
  font-size: 13.5px;
  color: #666 !important;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-link:hover { color: #cc0000 !important; }

.footer-address {
  font-size: 13.5px;
  color: #666;
  line-height: 1.6;
}

.footer-hours {
  font-size: 13.5px;
  color: #666;
}

.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.06);
  padding: 18px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-copy {
  font-size: 12px;
  color: #444;
}

.footer-tagline {
  font-size: 11px;
  font-weight: 700;
  color: #333;
  letter-spacing: 2px;
  text-transform: uppercase;
}

/* ══ MOBILE RESPONSIVE ══ */
@media (max-width: 768px) {
  /* Top bar: hide address on very small screens */
  .top-bar {
    padding: 0 16px;
    height: auto;
    min-height: 32px;
    padding-top: 6px;
    padding-bottom: 6px;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    font-size: 10.5px;
  }
  .top-bar-address { display: none; }

  /* Navbar */
  .navbar {
    padding: 0 16px;
    height: 64px;
    position: relative;
  }
  .navbar-right { display: none; }
  .hamburger { display: flex; }

  /* Mobile menu sits inside the fixed header */
  .mobile-menu { display: flex; }
  .mobile-overlay { display: block; }

  /* Shrink logo and brand */
  .nav-logo {
    height: 46px;
    width: 46px;
  }
  .brand-white, .brand-red {
    font-size: 15px;
    letter-spacing: 1px;
  }

  /* Content offset: topbar (~44px) + navbar (64px) */
  .site-content { margin-top: 108px; }

  /* Footer: stack columns */
  .footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    padding: 40px 20px 32px;
  }
  .footer-brand {
    grid-column: 1 / -1;
  }
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 16px 20px;
  }
}

@media (max-width: 480px) {
  .top-bar { font-size: 10px; }

  .footer-top {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 32px 16px 24px;
  }
  .footer-brand { grid-column: auto; }
  .footer-bottom { padding: 14px 16px; }
}
</style>
